module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch1_20210921035649_T.aa487bf8.jpg";